import React from 'react';
import {PropTypes} from 'prop-types';
import {BusinessBox} from 'components/fair/fair-business';
import {connect} from 'react-redux';
import {Fairs} from 'base/api';
import ReactPaginate from 'react-paginate';
import {toastr} from 'react-redux-toastr';
import axios from 'axios';
import cookie from 'react-cookie';

class BusinessList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      items: {},
      businesses: [],
      total: 0,
      offset: 0,
      pageCount: 0,
      searchTerm: '',
      API_URL: '',
      access_token: cookie.load('accessToken') || ''
    }
    this.fnCount = 'businesses/approved/count';
    this.findStatus = 1;
  }

  componentDidMount() {

    switch (this.props.status) {
      case 'AWAITING':
        this.findStatus = 0;
        break;
      case 'REJECTED':
        this.findStatus = 2;
        break;
      default:
        this.findStatus = 1;
    }

    Fairs.actions.get.request({id: this.props.match.params.id}).then(response => {;
      if (response.data) {
        this.setState({
          API_URL: response.data.fair.apiUrl
        }, () => {
          this.getData();
        })
      }
    });
  }

  getData (params) {
    axios.get(`${this.state.API_URL}/${this.fnCount}`,{
      params,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      this.setState({total: response.data.total}, () => {this.loadBusinessesFromServer(this.findStatus);})
    }).catch(error => {
      console.log(error)
    })
  }

  loadBusinessesFromServer(status) {
    let params = {
      filter: {
        limit: this.props.limit,
        skip: this.state.offset,
        order: 'createdAt DESC',
        counts: ['products', 'orders'],
        where: {
          status,
          name: {
            regexp: `/${this.state.searchTerm}/i`
          }
        }
      }
    }

    axios({
      method: 'GET',
      url: `${this.state.API_URL}/businesses`,
      params,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      let businesses = response.data || []
      this.postLoadBusinesses(businesses);
    }).catch(error => {
      console.log(error)
    })
  }

  postLoadBusinesses(businesses) {
    this.props.dispatch({
      type: 'UPDATE_LIST_BUSINESS_OF_FAIR',
      list: businesses
    });

    let itemKeys = {};
    businesses.map(item => {
      itemKeys[item.id] = item;
    });

    let pageCount = Math.ceil(this.state.total / this.props.limit);
    this.setState({
      items: itemKeys,
      pageCount
    });
  }

  removeBusiness(bizID) {
    if (confirm("Bạn có muốn xóa doanh nghiệp này khỏi hội chợ?")) {
      axios({
        method: 'DELETE',
        url: `${this.state.API_URL}/businesses/${bizID}/`,
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        toastr.success("Thành công", "Doanh nghiệp đã được xóa");
        this.props.dispatch({
          type: 'REMOVE_BUSINESS_OF_FAIR',
          businessId: bizID
        });
      }).catch(error => {
        console.log(error)
      })
    }
  }

  updateInfo(bizID) {
    axios({
      method: 'POST',
      url: `${this.state.API_URL}/businesses/${bizID}/approveUpdateInfo/`,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      this.loadBusinessesFromServer(this.findStatus)
    }).catch(error => {
      console.log(error)
    })
  }

  unlock(bizID) {
    if (confirm("Bạn chắc chắn muốn doanh nghiệp này tham gia hội chợ?")) {
      axios({
        method: 'PATCH',
        url: `${this.state.API_URL}/businesses/${bizID}/`,
        headers: {
          Authorization: `${this.state.access_token}`
        },
        data: {
          status: 1
        }
      }).then(response => {
        toastr.success("Thành công", 'Doanh nghiệp đã được tham gia hội chợ');
        this.updateInfo(bizID)
      }).catch(error => {
        console.log(error)
      })
    }
  }

  accept(bizID, bizDNTID) {
    if (confirm("Bạn đồng ý duyệt doanh nghiệp này?")) {
      Fairs.actions.acceptBusiness.request({id: this.props.match.params.id}, {dntBusinessId: bizDNTID.substring(4), pavoBusinessId: bizID}).then(response => {
        toastr.success("Thành công", 'Duyệt thành công');
      }).catch(error => {
        console.log(error)
      })
    }
  }

  unAccept(bizID, type) {
    if (type === 'lock' ? confirm("Bạn chắc chắn muốn khóa doanh nghiệp này?") : confirm("Bạn muốn từ chối doanh nghiệp này tham gia hội chợ?")) {
      axios({
        method: 'PATCH',
        url: `${this.state.API_URL}/businesses/${bizID}/`,
        headers: {
          Authorization: `${this.state.access_token}`
        },
        data: {
          status: 2
        }
      }).then(response => {
        toastr.success("Thành công", `${type === 'lock' ? 'Khóa thành công' : "Từ chối thành công"}`);
        this.updateInfo(bizID)
      }).catch(error => {
        console.log(error)
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.listBusinesses != prevProps.listBusinesses) {
      this.setState({
        listBusinesses: this.props.listBusinesses,
        businesses: this.props.listBusinesses,
      });
    }
  }

  onChange(e) {
    this.setState({
      searchTerm: e.target.value,
      offset: 0
    });
  }

  handleSearch(e) {
    e.preventDefault();
    this.loadBusinessesFromServer(this.findStatus);
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.limit);

    this.setState({offset: offset}, () => {
      this.loadBusinessesFromServer(this.findStatus);
    });
  };

  render() {
    return (
      <div>
        <form className="search-container" onSubmit={this.handleSearch.bind(this)}>
          <i className='fa fa-search' />
          <input type="text" className="search-input" value={this.state.searchTerm} placeholder="Tìm theo tên doanh nhiệp" onChange={this.onChange.bind(this)}/>
          <button type='submit' className='btn-submit'>Tìm kiếm</button>
        </form>
        <div className='row'>
          <div className="container-fluid">
            <div className='row'>
              {
                this.state.businesses.map(business => {
                  return (
                    <div className='col-lg-6 business-item'>
                      <BusinessBox key={business.id} FairId={this.props.match.params.id} data={business} unlock={this.unlock.bind(this)} removeBusiness={this.removeBusiness.bind(this)} accept={this.accept.bind(this)} unAccept={this.unAccept.bind(this)}/>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
        <ReactPaginate previousLabel={"previous"}
          nextLabel={"next"}
          breakLabel={<a href="">...</a>}
          breakClassName={"break-me"}
          pageCount={this.state.pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this.handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"} />
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    listBusinesses: state.fairs.list
  };
}

BusinessList.PropTypes = {
  status: PropTypes.oneOf(['AWAITING', 'ALL', 'REJECTED']),
  limit: PropTypes.number
}

BusinessList.defaultProps = {
  status: 'ALL',
  limit: 10
}

export default connect(mapStateToProps)(BusinessList);


// WEBPACK FOOTER //
// ./components/fair/fair-business/BusinessList.jsx